import React from 'react';
import WordCloudView from './common/WordCloudView';
import { siteUrl } from '../constants/global';

// A simple page that renders the word cloud. You can style/layout as needed.
const WordCloudPage = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '12px' }}>Community Takeaways Word Cloud</h2>
      <WordCloudView
        listId={1537}
        property={"what_takeaways_do_you_intend_to_carry_from_ciis_2021_"}
        fetchUrl={`${siteUrl}/community-rest-functions.php?action=hubspot_featch_remark&listId=1537&property=what_takeaways_do_you_intend_to_carry_from_ciis_2021_`}
      />
    </div>
  );
};

export default WordCloudPage;
